import { useState } from "react";

export const useMenu = () => {
	const [anchorEl, setAnchorEl] = useState(null);

	const openMenu = Boolean(anchorEl);
	const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
	const handleMenuClose = () => setAnchorEl(null);

	return {
		anchorEl,
		openMenu,
		handleMenuOpen,
		handleMenuClose,
	};
};
